import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import SbEditable from 'storyblok-react'
import classnames from 'classnames'

import TextRenderer from './../TextRenderer'
import ButtonMenu from './../ButtonMenu'
import Socials from './../Socials'

import LogoSvg from './../../graphics/logo.svg'

import styles from './styles.module.scss'

const Header = (props) => {

    const [menuActive, setMenuActive] = useState(false)
    const [headerSticky, setHeaderSticky] = useState(false)

    const headerClasses = classnames({
        [styles['header']]: true,
        [styles['header--sticky']]: headerSticky,
        [styles['header--active']]: menuActive,
    })

    const menuClasses = classnames({
        [styles['menu']]: true,
        [styles['menu--active']]: menuActive,
        [styles['menu--sticky']]: headerSticky
    })
    
    const scrollHandler = ({ element, useWindow }) => {
        const target = element ? element.current : document.body
        const position = target.getBoundingClientRect()
        const scrollPos = useWindow ? { x: window.scrollX, y: window.scrollY } : { x: position.left, y: position.top }    

        if (scrollPos.y < 0) {
            setHeaderSticky(true)
        } else if (scrollPos.y == 0) {
            setHeaderSticky(false)
        }
    }
    
    useEffect(() => {
        window.addEventListener('scroll', scrollHandler)
        
        return () => {
            window.removeEventListener('scroll', scrollHandler)
        }
    }, [])

    useEffect(() => {
        if (menuActive) {
            document.body.classList.add('no-scroll')
        } else {
            document.body.classList.remove('no-scroll')
        }
    }, [menuActive])

    return (
        <header className={headerClasses}>
            {props.blok.banner_link && props.blok.show_banner && props.blok.banner_label && (
                <Link className={styles['header__message']} to={`/${props.blok.banner_link.cached_url}`} style={{ backgroundColor: props.banner.color || props.blok.banner_background }}>
                    {props.blok.banner_label}
                </Link>
            )}
            <div className={`container ${styles['header__container']}`}>
                <Link to='/' className={styles['header__logo-link']}>
                    <LogoSvg className={styles['header__logo']} />
                </Link>
                <nav className={styles['header__navigation']}>
                    {props.blok.nav_items && (
                        <div className={styles['header__navigation-item-wrapper']}>
                            <Link to={`/${props.blok.nav_items[0].link.cached_url}`} className={styles['header__navigation-item']}>{props.blok.nav_items[0].name}</Link>
                        </div>
                    )}
                    <ButtonMenu 
                        className={styles['header__navigation-button']} 
                        onClick={() => setMenuActive(!menuActive)} 
                        menuActive={menuActive}
                    />
                    {props.blok.nav_items && (
                        <div className={styles['header__navigation-item-wrapper']}>
                            <Link to={`/${props.blok.nav_items[1].link.cached_url}`} className={styles['header__navigation-item']}>{props.blok.nav_items[1].name}</Link>
                        </div>
                    )}
                </nav>
                {props.blok.social_items && <Socials items={props.blok.social_items} className={styles['header__socials']} />}
            </div>
            <aside className={menuClasses}>
                <nav className={`container ${styles['menu__container']}`}>
                    <div className={`row ${styles['menu__row']}`}>
                        {props.blok.menu_columns && props.blok.menu_columns.map((blok, i) => {
                            return (
                                <div key={i} className={`col ${styles['menu-item__column']}`}>
                                    <h4 className={`heading-5 ${styles['menu-item__heading']}`}><b>{blok.heading}</b></h4>
                                    <TextRenderer text={blok.copy} className={styles['menu-item__text']} />
                                </div>
                            )
                        })}
                    </div>
                </nav>
            </aside>
        </header>
    )
}

export default Header
